<template>
    <el-row class="wheel">
      <el-col :span="spanLeft">
        <el-carousel height="250px">
          <el-carousel-item v-for="item in wheelList" :key="item.id">
            <el-image class="wheel-picture" :src="formatUrl(item.picture)"></el-image>
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="spanRight" class="msg">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>消息通知</span>
          </div>
          <div v-for="(item,index) in dataList" :key="item.id">
            <div class="font-overflow content pointer">{{index+1}}、{{getContent(item.content)}}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
</template>
<script>
    export default {
      props: {
        showNotice: {
          type: Boolean,
          default:true
        },
      },
      data(){
        return{
          dataList:[],
        }
      },
      mounted(){
        this.getList();
      },
      computed:{
        spanLeft(){
          return this.showNotice ? 16:24
        },
        spanRight(){
           return this.showNotice ? 8:0
        },
        wheelList(){
          let clone = this.dataList.clone();
          return clone.splice(0,3)
        },
      },
      methods: {
        getContent(str) {
          return str.replace(/<[^>]+>/g, "");  //正则去掉所有的html标记
        },
        //查询列表数据
        getList() {
          this.$request.doGet('/api/notice/getList', {}).then(res => {
            if (res.isOk) {
              this.dataList = res.list;
            }
          })
        },
      }
    };
</script>
<style scoped>
  .wheel {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: rgba(255, 255, 255, 0.62)
  }

  .wheel-picture {
    height: 100%;
    width: 100%;
    border-radius: 5px
  }

  .msg {
    padding-left: 10px;
  }

  .box-card {

    height: 250px;
    overflow-y: auto
  }

  .content {
    margin: 10px 5px;
    background: #f6f6f6;
    padding: 8px;
    border-radius: 5px;
    color: #333;
    font-family: cursive
  }

  .content:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  }


</style>



// WEBPACK FOOTER //
// src/components/sui-wheel/sui-wheel.vue